import { useState } from "react";
import InsertRoomBorrowingForm from "./components/InsertRoomBorrowingForm";
import useQueryParams from "@/lib/hooks/useQueryParams";
import { Button } from "@/components/ui/button/Button";
import InsertAssetBorrowingForm from "./components/InsertAssetBorrowingForm";
import LoadingIndicator from "@/components/ui/loading/LoadingIndicator";

const InsertBorrowing = () => {
  const { params, updateParams } = useQueryParams();
  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState(params.get("tab") || "Room");

  const handleTabChange = (tabName: string) => {
    setActiveTab(tabName);
    updateParams({ tab: tabName });
  };

  return (
    <div className="container mx-auto py-10 px-8">
      {loading && <LoadingIndicator loading={loading} />}
      <div className="text-lg">Insert Borrowing for Staff</div>
      <div className="flex gap-4 my-4">
        <Button
          variant="ghost"
          className={`btn shadow-lg shadow-secondary px-3 py-2 rounded text-sm font-medium border-2 border-transparent ${
            activeTab === "Room" ? "border-blue-500" : ""
          }`}
          onClick={() => handleTabChange("Room")}
        >
          Room
        </Button>
        <Button
          variant="ghost"
          className={`btn shadow-lg shadow-secondary px-3 py-2 rounded text-sm font-medium border-2 border-transparent ${
            activeTab === "Asset" ? "border-blue-500" : ""
          }`}
          onClick={() => handleTabChange("Asset")}
        >
          Asset
        </Button>
      </div>
      {activeTab === "Room" && (
        <InsertRoomBorrowingForm setLoading={setLoading} />
      )}
      {activeTab === "Asset" && (
        <InsertAssetBorrowingForm setLoading={setLoading} />
      )}
    </div>
  );
};

export default InsertBorrowing;
